import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import {
  PerformanceReviewProcessEditionWindowFragment,
  PerformanceReviewerStrategiesStrategyEnum,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { ReviewerTypeSection } from 'modules/performance_process/components/review/forms/ReviewerType'
import { useUpdateReviewProcessReviewerStrategies } from 'modules/performance_process/hooks/useUpdateReviewProcessReviewerStrategies'

interface Props {
  review: PerformanceReviewProcessEditionWindowFragment
}

export const ReviewTypes: React.FC<Props> = ({ review }) => {
  const { updateReviewerStrategies, loading } = useUpdateReviewProcessReviewerStrategies()

  const handleReviewerStrategiesChange = (
    reviewerStrategies: PerformanceReviewerStrategiesStrategyEnum[]
  ) => {
    updateReviewerStrategies({ id: review.id, reviewerStrategies })
  }

  return (
    <Box gap="s32">
      <Text size="400" color="grey1000" weight="semibold">
        {i18n.t('performance_process.reviews.launch_review_types')}
      </Text>
      <Text.Normal>
        {i18n.t('performance_process.reviews.create.reviewer_type_explanation_new')}
      </Text.Normal>
      <ReviewerTypeSection
        reviewerStrategies={review.reviewerStrategies || []}
        disabled={review.status !== 'draft' || loading}
        onChange={handleReviewerStrategiesChange}
      />
    </Box>
  )
}
